module.exports = __webpack_public_path__ + "static/media/crm-fit-out.3bef38bc.png";